import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { message } from 'antd'
import { updateSiteConfigs } from 'actions/Site'
import { fetchFaqCategories, deleteFaqCategory } from 'actions/Faq'
import FaqCategoriesView from 'components/pages/faq/categories'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchFaqCategories: bindActionCreators(fetchFaqCategories, dispatch),
  deleteFaqCategory: bindActionCreators(deleteFaqCategory, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isLoading', 'setIsLoading', false),
  withState('stateSearch', 'setStateSearch', {}),
  withState('data', 'setData', {}),
  withHandlers({
    getList: props => async (params) => {
      const { setData, setIsLoading } = props
      setIsLoading(true)
      try {
        const res = await props.fetchFaqCategories(params)
        setData({
          list: res.data,
          meta: res.meta,
        })
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  withHandlers({
    handleDelete: props => async (id) => {
      const { setIsLoading, getList } = props
      setIsLoading(true)

      try {
        const res = await props.deleteFaqCategory(id)
        message.success(res)
        getList()
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Faq Category',
        activePage: 'faq/category',
        activeSubPage: 'faq',
      })

      this.props.getList()
    },
  }),
)(FaqCategoriesView)
